module.exports = __webpack_public_path__ + "static/media/image.20f79380.png";